import React from "react";
import Button from "components/form/Button";
import { BUTTON_TEXT } from "constants/documents";
import { useTestAttrsFactory } from "utils/testid";

interface PaginationComponentProps {
  totalCount: number;
  perPage: number;
  currentPage: number;
  onPreviousClick?: (e?: any) => void;
  onNextClick?: (e?: any) => void;
  isTableLoading?: boolean;
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({
  totalCount,
  perPage,
  currentPage,
  onPreviousClick,
  onNextClick,
  isTableLoading = false,
}) => {
  const testAttrs = useTestAttrsFactory();
  const totalPages = Math.ceil(totalCount / perPage) || 0;
  const startRow = (currentPage - 1) * perPage + 1;
  const endRow = Math.min(totalCount, currentPage * perPage);

  return (
    <div
      className="py-3 flex justify-between items-center lg:border-y border-t border-strokePrimary"
      {...testAttrs("pagination", "Documents pagination")}
    >
      <div
        className="text-sm font-normal leading-5 text-txtPrimary"
        {...testAttrs("pagination-summary")}
      >
        {`Viewing ${startRow}-${endRow} of ${totalCount} results`}
      </div>
      <div className="flex items-center gap-2">
        <Button
          isDisabled={isTableLoading || currentPage === 1}
          variant="stroke-outline"
          text={BUTTON_TEXT.PREVIOUS}
          className={`!py-1 !px-2 !text-sm !leading-[18.23px] ${
            isTableLoading || currentPage === 1
              ? "hover:!bg-btnOutlineInactive"
              : "hover:!bg-btnOutlineActive"
          }`}
          {...testAttrs("previous-page", "Previous documents page")}
          onClick={onPreviousClick}
        />
        <Button
          isDisabled={isTableLoading || currentPage >= totalPages}
          variant="stroke-outline"
          text={BUTTON_TEXT.NEXT}
          className={`!py-1 !px-2 !text-sm !leading-[18.23px] ${
            isTableLoading || currentPage >= totalPages
              ? "hover:!bg-btnOutlineInactive"
              : "hover:!bg-btnOutlineActive"
          }`}
          {...testAttrs("next-page", "Next documents page")}
          onClick={onNextClick}
        />
      </div>
    </div>
  );
};

export default PaginationComponent;
